/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Personal / Commercial License.
 * See LICENSE_PERSONAL / LICENSE_COMMERCIAL in the project root for license information on type of purchased license.
 */

import { Component } from '@angular/core';

@Component({
  selector: 'ngx-footer',
  styleUrls: ['./footer.component.scss'],
  template: `
    <div style="width: 60%!important;">
      <img class="img-banner" style="width: 10%!important;"
      src="assets/images/d-r-horton-1.png" /><br>
      <span class="created-by" style="font-size: 0.7rem!important;">D.R. Horton is an equal housing opportunity builder. Elevations, materials, artist renderings, 
        colors, features, and sizes are for illustration purposes only and will vary from the homes as built. ©D.R. Horton, Inc. 2022.
      </span>
    </div>   
    <div class="">
      <span class="created-by">© 2019 <b><a href="https://artisticvisions.com" target="_blank">Artistic Visions </a></b> LLC</span>
      <a class="px-3" routerLink="legal/terms">Terms and Conditions</a>
      <a class="px-3" routerLink="legal/policy">Privacy Policy</a>
    </div>
  `,
})
export class FooterComponent {
}
